import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const TripList = () => {
  const [upcomingTrips, setUpcomingTrips] = useState([]);
  const [pastTrips, setPastTrips] = useState([]);
  const navigate = useNavigate();
  const [tripImages, setTripImages] = useState({});

  useEffect(() => {
    const fetchTrips = async () => {
      const token = localStorage.getItem("token");
      const response = await fetch(`${process.env.REACT_APP_API_URL}/trips/my_trips/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();

      const today = new Date().toISOString().split("T")[0];

      const tripMap = {};
      const parents = [];

      data.forEach(trip => {
        tripMap[trip.id] = { ...trip, subTrips: [] };
      });

      data.forEach(trip => {
        if (trip.parent_trip_id) {
          tripMap[trip.parent_trip_id]?.subTrips.push(tripMap[trip.id]);
        } else {
          parents.push(tripMap[trip.id]);
        }
      });

      Object.values(tripMap).forEach(trip => {
        trip.subTrips.sort((a, b) => a.start_date.localeCompare(b.start_date));
      });

      const upcoming = [];
      const past = [];

      parents.forEach(trip => {
        if (trip.end_date >= today) {
          upcoming.push(trip);
        } else {
          past.push(trip);
        }
      });

      upcoming.sort((a, b) => a.start_date.localeCompare(b.start_date));
      past.sort((a, b) => b.start_date.localeCompare(a.start_date));

      setUpcomingTrips(upcoming);
      setPastTrips(past);
	  
		// fetch images
		const allTrips = [...upcoming, ...past];
		const images = {};

		await Promise.all(allTrips.map(async (trip) => {
		  const keyword = trip.subTrips[0]?.name || trip.name || "travel";
		  try {
			const res = await fetch(`https://api.pexels.com/v1/search?query=${encodeURIComponent(keyword)}&per_page=1`, {
			  headers: {
				Authorization: "mS63Oj7yk8NzO2wFn04Phmogx93gWFqrEoSNASDa2BvDZNRntOQrnQda"
			  }
			});
			const data = await res.json();
			images[trip.id] = data.photos[0]?.src?.medium || "fallback_url.jpg";
		  } catch (err) {
			images[trip.id] = "fallback_url.jpg";
		  }
		}));

		setTripImages(images);
	  };

	  fetchTrips();
	}, []);

  const formatDateRange = (start, end) => {
    const options = { month: "short", day: "2-digit" };
    const startDate = new Date(start);
    const endDate = new Date(end);

    const sameMonth = startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear();

    const startStr = startDate.toLocaleDateString("en-US", options);
    const endStr = endDate.toLocaleDateString("en-US", options);

    const endMonthStr = endDate.toLocaleDateString("en-US", { month: "short" });
    return sameMonth
      ? `${startStr} - ${endDate.getDate().toString().padStart(2, '0')}`
      : `${startStr} - ${endMonthStr} ${endDate.getDate().toString().padStart(2, '0')}`;
  };

  const renderTripGrid = (title, trips) => (
    <div className="mb-10 responsive-container">
      <h3 className="heading mb-4">{title}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
        {trips.map(trip => (
          <div
            key={trip.id}
            className="bg-white rounded-2xl shadow-md hover:shadow-lg cursor-pointer transition overflow-hidden"
            onClick={() => navigate(`/edit-trip/${trip.id}`)}
          >
            <img
			  src={tripImages[trip.id] || "fallback_url.jpg"}
			  alt={trip.name}
			  className="h-40 w-full object-cover"
            />
            <div className="p-3">
              <h4 className="text-base font-semibold truncate" title={trip.name}>
                {trip.name}
              </h4>
              <p className="text-sm text-gray-500 mt-1">
                {formatDateRange(trip.start_date, trip.end_date)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="py-6">
      {renderTripGrid("Upcoming Trips", upcomingTrips)}
      {renderTripGrid("Past Trips", pastTrips)}
    </div>
  );
};

export default TripList;
